<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">Invoices</h2>
      <p class="text-center">
        List of invoices of {{ sellerName }}
      </p>
    </div>
    <div class="row mt-5">

      <!-- QUERY OPTIONS -->
      <div class="col-12">
        <card>
          <div class="row">
            <!-- DATE RANGE PICKER -->
            <div class="col-12 col-md-6 col-lg-6">
              <el-date-picker v-model="dates" type="daterange" range-separator="～"
                start-placeholder="開始日期" end-placeholder="結束日期"
                :picker-options="pickerOptions" @change="onDateRangePicked">
              </el-date-picker>
            </div>

            <!-- STATUS FILTER -->
            <div class="col-12 col-md-6 col-lg-3">
              <el-form label-position="right">
                <el-form-item label="Status">
                  <el-select multiple size="large" v-model="select.status.model"
                    collapse-tags placeholder="Status">
                    <el-option class="select-info" v-for="option in select.status.options"
                      :value="option.value" :label="option.label" :key="option.label" >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>

            <!-- INV-YM PERIODS SELECTOR -->
            <div class="col-12 col-md-6 col-lg-3">
              <el-form label-position="right">
                <el-form-item label="期數">
                  <el-select class="select-primary" size="large"
                    placeholder="Single Select" v-model="select.periods.model">
                    <el-option
                      v-for="option in select.periods.options"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>

            <div class="col-12 col-md-6 col-lg-6">
              <KeywordWidget :search-props="searchableProps" @change="onSearchRequested">
              </KeywordWidget>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <base-button type="primary" class="btn-icon-only" @click="refreshList">
                <span class="btn-inner--icon"><i class="tim-icons icon-refresh-01"></i></span>
              </base-button>
              <base-button type="warning" size="md" @click="exportInvoices">
                <i class="tim-icons icon-cloud-download-93"></i> 匯出成Excel
              </base-button>
            </div>
          </div>
        </card>
      </div>

      <!-- INVOICE TABLE -->
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <!-- <h4 slot="header" class="card-title text-left">Invoices</h4> -->
          <div>

            <SSRTable ref="list-invoices" :data-url="urlInvoices" :schema="schema.invoices"
              data-key="invoices">

              <div slot="invoice_number" slot-scope="{row}">
                <strong>{{ row.invoice_number }}</strong><br>
                <span>期數 {{ row.ym }}</span>
              </div>

              <div slot="uploaded_at" slot-scope="{row}">
                <span style="color:gray;">
                  開立 {{ row.written_at }}
                </span>
                <span v-if="row.uploaded_at">
                  <br>上傳 {{ row.uploaded_at }}
                </span>
                <span style="color:red;" v-if="row.cancelled_at">
                  <br>作廢 {{ row.cancelled_at }}
                </span>
              </div>

              <div slot="status" slot-scope="{row}">
                {{ toStatusLiteral(row.status) }}
              </div>

              <div slot="amount" slot-scope="{row}">
                ${{ Number(row.amount).toLocaleString() }}
              </div>

              <div slot="carrier_id1" slot-scope="{row}">
                <span v-if="row.carrier_id1">{{ row.carrier_id1 }}</span><br>
                <span v-if="row.buyer_tax_id && row.buyer_tax_id !== '0000000000'">{{ row.buyer_tax_id }}</span>
              </div>

              <div slot="actions" slot-scope="{row}">
                <base-button type="info" size="sm" round icon class="mr-1">
                  <i class="tim-icons icon-alert-circle-exc"></i>
                </base-button>
                <base-button type="primary" size="sm" class="mr-1" v-if="row.status == 'written'"
                  @click="upload(row)">
                  <i class="tim-icons icon-upload"></i> 上傳
                </base-button>
                <base-button type="danger" size="sm" class="mr-1" v-if="[ 'written', 'uploaded' ].indexOf(row.status) >= 0"
                  @click="cancel(row)">
                  <i class="tim-icons icon-trash-simple"></i> 作廢
                </base-button>
              </div>
            </SSRTable>

          </div>
          
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { Card, BasePagination, BaseInput } from "@/components/index";
import SSRTable from '@/components/SSRTable.vue';
import KeywordWidget from '@/components/KeywordWidget.vue';

import moment from 'moment';
import axios from 'axios';

export default {
  components: {
    Card,
    [Select.name]: Select,
    [Option.name]: Option,
    // [Table.name]: Table,
    // [TableColumn.name]: TableColumn,
    // BasePagination,
    BaseInput,

    SSRTable,
    KeywordWidget
  },

  mounted() {
  
    // Init options for inv periods select
    let m = moment();
    let momentToInvPeriod = m => {
      return m.format('YYYY') + {
        '01': '02', '02': '02', '03': '04', '04': '04',
        '05': '06', '06': '06', '07': '08', '08': '08',
        '09': '10', '10': '10', '11': '12', '12': '12'
      }[ m.format('MM') ]
    };
    this.select.periods.model = momentToInvPeriod(m);
    for (let i=0; i<6; i++) {//FIXME: Allow queries for the most recent 12 months.
      let temp = momentToInvPeriod(m);
      this.select.periods.options.push({
        value: temp, label: temp
      });
      m = m.add(-2, 'months');
    }
  },

  methods: {
    onDateRangePicked() {
      // console.warn(`onDateRangePicked`, this.dates);
    },
    onSearchRequested(args) {
      console.warn(`onSearchRequested`, args);
      this.keyword = args.keyword;
      this.searchBy = args.prop;
    },

    upload(inv) {
      this.$swal({
        title: `上傳發票 ${inv['invoice_number']}`,
        text: `確定上傳商家 ${inv['seller_name']} 的發票 ${inv['invoice_number']}？`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false
      })
      .then(result => {
        if (!result.isConfirmed) return;

        // Attempt to upload by invoice number.
        axios.post(
          `${process.env.VUE_APP_QINVOICE_API_HOST}/sellers/${this.sellerId}/upload/${inv['invoice_number']}`,
          { ym: inv['ym'] }
        )
        .then(response => {
          console.log(`[INVOICES] Cancellation of invoice ${inv['invoice_number']} was successful.`, response.data);
          this.$notify({
            type: 'success', message: `發票${inv['invoice_number']}已上傳成功！`
          });

          // Forcibly refresh the list.
          this.refreshList();
        })
        .catch(err => {
          console.error(`[INVOICES] Upload of invoice ${inv['invoice_number']} has failed.`, err);
          let showMsg = `發票${inv['invoice_number']}上傳失敗！請稍後再試，或聯繫電子發票服務供應廠商處理。`;
          if (err.response && err.response.data && err.response.data.data)
            showMsg += `\n${err.response.data.data.retVal}`
          this.$notify({
            type: 'danger', message: showMsg
          });
        });
      })
      .catch(this.$swal.noop);
    },

    cancel(inv) {
      // let reason = prompt(`確定要作廢發票 ${inv['invoice_number']} 嗎？此動作無法復原。\n可填入作廢的原因。`, '');
      // Show a prompt for confirmation and reason.
      this.$swal({
        title: `嘗試作廢發票${inv['invoice_number']}`,
        input: 'text',
        inputLabel: '確定要作廢此發票？此操作無法復原。\n請提供作廢理由。',
        inputValue: '',
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false
      })
      .then(result => {
        console.log(`SWAL`, result);
        if (!result.isConfirmed) return;

        let reason = result.value || 'By QInvoice-admin.';
        // reason += ` (by ${this.username})`;
        axios.post(
          `${process.env.VUE_APP_QINVOICE_API_HOST}/sellers/${this.sellerId}/invoices`
          + `/${inv['invoice_number']}/cancel`,
          { ym: inv['ym'], reason }
        )
        .then(response => {
          console.log(`[INVOICES] Cancellation of invoice ${inv['invoice_number']} was successful.`, response.data);
          this.$notify({
            type: 'warning', message: `發票${inv['invoice_number']}已作廢。`
          });

          // Forcibly refresh the list.
          this.refreshList();
        })
        .catch(err => {
          console.error(`[INVOICES] Cancellation of invoice ${inv['invoice_number']} has failed.`, err);
          this.$notify({
            type: 'danger', message: `發票${inv['invoice_number']}作廢失敗！請稍後再試，或聯繫電子發票服務供應廠商處理。`
          });
        });
      })
      .catch(this.$swal.noop);
    },

    exportInvoices() {
      let fromTs = moment(this.dates[0]).unix();
      let toTs = moment(this.dates[1]).endOf('day').unix();
      let timeProp = 'written_at';
      if (this.select.status.model.includes('created'))
        timeProp = 'created_at';
      window.open(
        `${process.env.VUE_APP_QINVOICE_API_HOST}/sellers/${this.sellerId}/invoices/export`
        + `?from=${fromTs}&to=${toTs}&timeProp=${timeProp}`
        + (this.select.status.model && this.select.status.model? `&status=${this.select.status.model}`: '')
        + `&timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
      );
    },

    refreshList() {
      this.$refs['list-invoices'].loadData();
    }
  },
  
  data() {
    return {
      dates: [
        moment().startOf('month').toDate(),
        moment().endOf('day').toDate()
      ],

      schema: {
        invoices: [
          { key: 'invoice_number', label: '發票號碼' },
          { key: 'uploaded_at', label: '開立上傳時間' },
          { key: 'status', label: '狀態', align: 'center' },
          { key: 'merchant_order_id', label: '商家訂單ID' },
          { key: 'carrier_id1', label: '載具ID/買方統編' },
          { key: 'amount', label: '金額', align: 'right', width: 120 },
          { key: 'actions', label: '' }
        ]
      },

      select: {
        status: {
          model: [ 'written', 'uploaded', 'cancelled', 'allowanced' ],
          options: [
            { value: 'created', label: '已取號' },
            { value: 'written', label: '已寫入' },
            { value: 'uploaded', label: '已開立上傳' },
            { value: 'cancelled', label: '已作廢' },
            { value: 'allowanced', label: '已折讓' }
          ]
        },
        periods: {
          model: '',
          options: [ ]
        }
      },

      pickerOptions: {
        shortcuts: [
          {
            text: '昨日',
            onClick(picker) {
              let d = moment().add(-1, 'days');
              picker.$emit('pick', [
                d.startOf('day').toDate(), d.endOf('day').toDate()
              ]);
            }
          },
          {
            text: '今日',
            onClick(picker) {
              let d = moment();
              picker.$emit('pick', [
                d.startOf('day').toDate(), d.endOf('day').toDate()
              ]);
            }
          }
        ]
      },

      searchBy: undefined,
      keyword: '',
      searchableProps: [
        { value: 'invoice_number', label: '發票號碼' },
        { value: 'merchant_order_id', label: '商家訂單ID' },
        { value: 'buyer_tax_id', label: '買方統編' },
        { value: 'carrier_id1', label: '手機載具' }
      ],

      toStatusLiteral(s) {
        return {
          'created': '已取號',
          'written': '已寫入',
          'uploaded': '已開立上傳',
          'cancelled': '已作廢',
          'allowanced': '已折讓',
        }[ s ];
      }
    };
  },

  computed: {
    urlInvoices() {
      let fromTs = moment(this.dates[0]).unix();
      let toTs = moment(this.dates[1]).endOf('day').unix();
      let timeProp = 'written_at';
      if (this.select.status.model.includes('created'))
        timeProp = 'created_at';
      return `${process.env.VUE_APP_QINVOICE_API_HOST}/sellers/${this.sellerId}/invoices`
        + `?from=${fromTs}&to=${toTs}&timeProp=${timeProp}`
        + (this.select.status.model && this.select.status.model? `&status=${this.select.status.model}`: '')
        + (this.select.periods.model? `&ym=${this.select.periods.model}`: '')
        + (this.searchBy && this.keyword.length? `&search=${this.searchBy}:${this.keyword}`: '')
        + `&timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`;
    },

    username() {
      return this.$store.getters.user['username'];
    },
    sellerId() {
      return this.$store.getters.user['seller']? this.$store.getters.user['seller']['id']: undefined;
    },
    sellerName() {
      return this.$store.getters.user['seller']? this.$store.getters.user['seller']['name']: '';
    }
  },

  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    // searchQuery(value) {
    //   let result = this.tableData;
    //   if (value !== "") {
    //     result = this.fuseSearch.search(this.searchQuery);
    //   }
    //   this.searchedData = result;
    // }
  }
};
</script>
<style></style>
